<div class="flex flex-col items-start gap-[0.5rem] pb-[0.625rem] min-w-[20rem] max-w-[23rem]">
  @for (item of textList; track item) {
    @if (textList) {
      <div class="flex start-flex flex-row items-center justify-start gap-[0.375rem] ">
        <div class="flex flex-col items-start pt-[0.15625rem]">
          <div class="circle margin-tp-negative-0p15625">
            @if (showIcons) {
              <app-all-icons
                [iconNameAndStyling]="'close.svg; icon-size-0p78125 '">
              </app-all-icons>
            }
          </div>
        </div>
        <div class="max-w-[26.34375rem]">{{item}}</div>
      </div>
    }
  }
</div>
